(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chd-brand-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chd-brand-video')) {
  customElements.define('chd-brand-video', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const error = this.querySelector('[role="status"]');
      if (!video || !button) return;
      let attempt = 0;
      let retryLoad = false;
      const clearTimer = () => window.clearTimeout(this.playTimer);
      const showError = () => {
        clearTimer();
        retryLoad = true;
        button.hidden = false;
        error.hidden = false;
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        const currentAttempt = ++attempt;
        clearTimer();
        button.hidden = true;
        error.hidden = true;
        if (retryLoad || video.error || video.networkState === video.NETWORK_NO_SOURCE) video.load();
        retryLoad = false;
        this.playTimer = window.setTimeout(() => {
          if (currentAttempt !== attempt) return;
          video.pause();
          showError();
        }, 15000);
        video.play().then(() => {
          if (currentAttempt !== attempt || !this.isConnected) return;
          clearTimer();
          video.focus({ preventScroll: true });
        }).catch(() => {
          if (currentAttempt === attempt && this.isConnected) showError();
        });
      }, options);
      video.addEventListener('play', () => {
        button.hidden = true;
        error.hidden = true;
        document.querySelectorAll('chd-brand-video video').forEach(other => {
          if (other !== video) other.pause();
        });
      }, options);
      video.addEventListener('playing', clearTimer, options);
      video.addEventListener('ended', () => { button.hidden = false; }, options);
      video.addEventListener('error', showError, options);
    }
    disconnectedCallback() {
      window.clearTimeout(this.playTimer);
      this.querySelector('video')?.pause();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chd-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-chd-video-toggle]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let userStarted = false;
    let visible = false;
    let failed = false;
    let pending = false;
    const update = () => {
      root.classList.toggle('is-playing', !video.paused);
      toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    };
    const shouldPlay = () => !failed && visible && !document.hidden && !userPaused && (userStarted || (!reducedMotion.matches && !navigator.connection?.saveData));
    const sync = async () => {
      if (!shouldPlay()) { video.pause(); update(); return; }
      if (pending || !video.paused) return;
      if (!video.getAttribute('src')) {
        video.src = matchMedia('(max-width:749px)').matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        video.muted = true;
      }
      pending = true;
      try { await video.play(); if (!shouldPlay()) video.pause(); }
      catch (_) { if (shouldPlay()) userPaused = true; }
      finally { pending = false; update(); }
    };
    video.addEventListener('playing', () => { root.classList.add('is-loaded'); update(); });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('error', () => { failed = true; root.classList.remove('is-loaded', 'is-playing'); toggle.hidden = true; });
    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      userPaused = !video.paused;
      if (!userPaused) userStarted = true;
      sync();
    });
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }, { threshold: 0.1 });
    observer.observe(root);
    document.addEventListener('visibilitychange', sync);
    reducedMotion.addEventListener('change', () => { userStarted = false; sync(); });
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { observer.disconnect(); document.removeEventListener('visibilitychange', sync); video.pause(); });
  };
  const start = () => document.querySelectorAll('[data-chd-hero-video]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
